import { render, staticRenderFns } from "./DnsDetails.vue?vue&type=template&id=317470cb&scoped=true&"
import script from "./DnsDetails.vue?vue&type=script&lang=js&"
export * from "./DnsDetails.vue?vue&type=script&lang=js&"
import style0 from "./DnsDetails.vue?vue&type=style&index=0&id=317470cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317470cb",
  null
  
)

export default component.exports